import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const backdropTransition = { type: "tween", duration: 0.2, ease: "easeOut" };
const contentSpring = { type: "spring", stiffness: 400, damping: 35 };
const contentReduced = { type: "tween", duration: 0.25, ease: "easeOut" };

function AnimatedPopup({ children, className = "", overflow = "hidden", style = {} }) {
  const reduceMotion = useReducedMotion() === true;
  const contentTransition = reduceMotion ? contentReduced : contentSpring;

  return (
    <>
      <motion.div
        className="position-fixed start-0 top-0 w-100 h-100"
        style={{
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.45)",
          zIndex: 1000,
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={backdropTransition}
        aria-hidden
      />
      <motion.div
        className={`position-fixed start-0 top-0 w-100 h-100 overflow-${overflow} ${className}`.trim()}
        style={{
          zIndex: 1001,
          ...style,
        }}
        initial={{ opacity: 0, scale: 0.96, y: 12 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={contentTransition}
      >
        {children}
      </motion.div>
    </>
  );
}

export default AnimatedPopup;
